import { ReplyIcon } from "@heroicons/react/outline";
import { useNavigate } from "react-router-dom";
import Button from "../UI/Button";

function Unauthorized() {
  const navigate = useNavigate();
  return (
    <div className="container mx-auto w-full flex flex-col text-center items-center py-5 h-screen/75 justify-center">
      <h1 className="text-4xl">Access Denied</h1>
      <h3>You are not authorized to access this page</h3>
      {/* <p>Would you like to Sign In into your portal account ?</p> */}
      <Button
        btnStyle="btn-primary"
        customClassName="mt-5"
        label="Back to Home"
        icon={<ReplyIcon className="h-5 w-5" />}
        onClick={() => navigate("/auth/sign_in", { replace: true })}
      />
    </div>
  );
}

export default Unauthorized;
